module.exports = __webpack_public_path__ + "img/fronius-inverter-lg.071c059f.svg";